import { defineComponent, onMounted } from 'vue';
import PopUp from '../PopUp/PopUp.vue';
import Incentives from './Incentives/Incentives.vue';
import LeftContentContainer from './LeftContentContainer/LeftContentContainer.vue';
import ExperimentAOptInPopUp from './ExperimentAOptInPopUp.class';
import { setupIncentive } from '../incentive-base';
import RightContentContainer from './RightContentContainer/RightContentContainer.vue';

export default defineComponent({
	components: {
		PopUp,
		Incentives,
		LeftContentContainer,
		RightContentContainer,
	},
	props: {
		appIdentifier: String,
	},
	setup: (props) => {
		const component = setupIncentive(new ExperimentAOptInPopUp());
		onMounted(component.mounted.bind(component));

		return {
			notNow: component.notNow.bind(component),
			accept: component.accept.bind(component),
			trackImpression: component.trackImpression.bind(component),
			appIdentifier: props.appIdentifier,
		};
	},
});
